import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TextField } from "@mui/material";
import { Grid } from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import { cloaseDonePopup, EditProductTableStart } from "../../../Redux/Actions/InputData";
import { EditProductTableError, EditProductTableSuccess, openErrorDialog } from "../../../Redux/Actions/InputData";
import { 
    API_BASE_URL, 
    MEDIUM_EDIT_NUT_MANUFACTURING_MASTER_1_TABLE_API,
    NEW_BULK_EDIT_HOME_SHIFTCHANGEOVER_UPDATEBYID_API
 } from "../../../Utils/Config";
import { putRequest } from "../../../Services/AxiosConfiguration";
import _ from "underscore";
import "./style.css";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function EditModal(props: any) {
    const { editedData } = props;   
    const dispatch: any = useDispatch();
    const [isDone, setIsDone] = useState(false);

    const handleCloseDonePopup = () => {
       
        editedData.capacity = props?.resetValues?.capacity;
        props.onClose();
        // setIsDone(false);
        // dispatch(cloaseDonePopup());
    };

    const validationSchema = Yup.object().shape({
        capacity: Yup.string().required('Capacity is required')
    });

    const { register, control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = () => {
        // const requestParam = { "table": "Manufacturing_1_data", "id": props.editedData.id, "values": { "Grammage": data.Grammage, "Design Speed": data["Design Speed"] } };
        dispatch(EditProductTableStart());
        const urls = API_BASE_URL + NEW_BULK_EDIT_HOME_SHIFTCHANGEOVER_UPDATEBYID_API;
        const header = { accept: "application/json", "Content-Type": "application/json" };
        putRequest(urls, editedData, header, {}).then((response) => {
            if (response.status === 200) {
                dispatch(EditProductTableSuccess(response.data));
            }
            setIsDone(true);
        }).catch((error) => {
            dispatch(openErrorDialog(error));
            dispatch(EditProductTableError(error));
        });
        setTimeout(() => {
            props.onClose();
        }, 200);

    };

    const selectedCategoryId = useSelector(
        (state: any) => state.InputDataReducers.selectedCategoryId
      );

    return (
        <>
            <BootstrapDialog className="edit-dialog" onClose={props.onClose} aria-labelledby="customized-dialog-title" open={props.isOpen}>
                <div className="modal-header">
                    <Grid container spacing={1}>
                        <Grid item xs={10} md={10} lg={10}>
                            <h3>{props.headerName}</h3>
                            <span className="title-note">Edit table content</span>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <CancelIcon className="cancel-icon" onClick={props.onClose} />
                        </Grid>
                    </Grid>
                </div>
                <div>
                    <DialogContent className="modal-body">
                              <form> 
                              <Grid direction='row' container spacing={2} mb={2}>
                                  <Grid container item sm={6} md={6} lg={6}>
                                      <TextField type="text" label="Factory Code" variant="outlined" defaultValue={editedData.factory_Code} disabled />
                                  </Grid>
                                  <Grid container item sm={6}>
                                      <TextField type="text" label="Factory" variant="outlined" defaultValue={editedData.factory} disabled />
                                  </Grid>
                              </Grid>
  
                              <Grid direction='row' container spacing={2} mb={2}>
                                  <Grid container item sm={6} md={6} lg={6}>
                                      <TextField type="text" label="Format" variant="outlined" defaultValue={editedData.format} disabled />
                                  </Grid>
                                  <Grid container item sm={6}>
                                      <TextField type="text" label="Cascade" variant="outlined" defaultValue={editedData.cascade} disabled />
                                  </Grid>
                              </Grid>
  
                              <Grid direction='row' container spacing={2} mb={2}>
                              <Grid container item sm={6}>
                                      <TextField onKeyDown={(evt) => ["e", "E", "+"].includes(evt.key) && evt.preventDefault()} type="number" label="Capacity" variant="outlined" {...register('capacity')} required error={errors.capacity ? true : false} defaultValue={editedData.capacity} onChange={(e) => editedData.capacity = e.target.value} />
                                  </Grid>
                              <Grid container item sm={6} md={6} lg={6}>
                                      <TextField type="text" label="Product" variant="outlined" defaultValue={editedData.product} disabled />
                                  </Grid>
                              </Grid>
                              <Grid direction='row' container spacing={2} mb={2}>
                                  <Grid container item sm={6}>
                                      <div className="error-msg">
                                          {errors.capacity ? 'Invalid capacity' : false}
                                      </div>
                                  </Grid>
                              </Grid>
                          </form>
                    </DialogContent>
                    <DialogActions>
                        <div className="modal-action">
                            {/* handleSubmit(editedData, props) */}
                            <Button variant="outlined" className="cancel" onClick={handleCloseDonePopup}>Cancel</Button>
                            <Button variant="contained" className="save" onClick={handleSubmit(onSubmit)}>Save Table Row</Button>
                        </div>
                    </DialogActions>
                </div>
            </BootstrapDialog>
        </>
    );
}

export default EditModal;

